export default __webpack_public_path__ + "static/media/bigWheel.39493b09.svg";